import { render, staticRenderFns } from "./orgTree.vue?vue&type=template&id=72a24767&"
import script from "./orgTree.vue?vue&type=script&lang=js&"
export * from "./orgTree.vue?vue&type=script&lang=js&"
import style0 from "./orgTree.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports